import SignUpContainer from './containers/SignUpContainer';

export default SignUpContainer;
